(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("playkit", [], factory);
	else if(typeof exports === 'object')
		exports["playkit"] = factory();
	else
		root["playkit"] = root["playkit"] || {}, root["playkit"]["core"] = factory();
})(self, function() {
return 